import getDataLayer from './getDataLayer';
import { getOwnCategory } from '../getOwnCategory';
import { DL_CURRENCY, DlEcommerceEvents } from './constant';
import { IProduct } from '../../typings/IProduct';

export const DL_AddToWishlist = (product: IProduct, dlItemIndex?: number) => {
  const customCategory = getOwnCategory(product?.customCategories);
  const productPrice = product?.productOptions[0]?.salePrice || product?.productOptions[0]?.price;
  getDataLayer().push({
    event: DlEcommerceEvents.ADD_TO_WISHLIST,
    ecommerce: {
      currency: DL_CURRENCY,
      value: productPrice,
      items: [
        {
          item_name: product?.titleDe || product?.title,
          item_id: product?.id,
          item_category: customCategory?.name,
          item_brand: product?.brand?.nameDe,
          price: productPrice,
          quantity: 1,
          index: dlItemIndex,
        },
      ],
    },
  });
};
